import { BaseEntity } from "yt-ng-framework";

export class Vozilo extends BaseEntity{
    constructor(){
        super();
    }
    Naziv: string = null;
    DatumReg: Date = null;
    VrstaVozilaId: number = null;
    RgBr: string = null;
    BrSbDozv: string = null;
    Marka: string = null;
    Model: string = null;
    Masa: number = null;
    Nosivost: number = null;
    BrojOsovina: number = null;
    GodinaProizvodnje: number = null;
    Boja: string = null;
    BrojSasije: string = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.DatumReg = input.DatumReg;
        this.VrstaVozilaId = input.VrstaVozilaId;
        this.RgBr = input.RgBr;
        this.BrSbDozv = input.BrSbDozv;
        this.Marka = input.Marka;
        this.Model = input.Model;
        this.Masa = input.Masa;
        this.Nosivost = input.Nosivost;
        this.BrojOsovina = input.BrojOsovina;
        this.GodinaProizvodnje = input.GodinaProizvodnje;
        this.Boja = input.Boja;
        this.BrojSasije = input.BrojSasije;
        
        return this;
    }

    Serialize(input: Vozilo){
        return input;
    }
}